import { render, staticRenderFns } from "./chong.vue?vue&type=template&id=3ef5678b&scoped=true&"
import script from "./chong.vue?vue&type=script&lang=js&"
export * from "./chong.vue?vue&type=script&lang=js&"
import style0 from "./chong.vue?vue&type=style&index=0&id=3ef5678b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5678b",
  null
  
)

export default component.exports